export default __webpack_public_path__ + "static/media/top-b-11.f6ff9b3f.jpg";